export default "__VITE_ASSET__BWjaofjE__"